// removed by extract-text-webpack-plugin
module.exports = {"muteSwitchContainer":"ec0Tg","iconContainer":"_24YfB","iconLabel":"_3Gd9v"};